module.exports = __webpack_public_path__ + "media/images/admin/icons/trending-up-ebfe9a72d68a3815181771098350599d.svg";